export default function changeWebsiteTitleDescription(title, description) {
	const div = document.createElement('div');
	div.innerHTML = title;
	title = div.textContent;
	div.innerHTML = description;
	description = div.textContent.substring(0, 500);
	document.title = title;
	const meta = document.querySelector('meta[name="description"]');
	if (!meta) {
		const meta = document.createElement('meta');
		meta.setAttribute('name', 'description');
		meta.setAttribute('content', description);
		document.head.appendChild(meta);
	}
	else {
		meta.setAttribute('content', description);
	}
}

export function clearWebsiteTitleDescription() {
	document.title = 'Carrier Community';
	const meta = document.querySelector('meta[name="description"]');
	if (meta) meta.remove();
}